import app from 'app';

app.namespace.Controller.Dialog = class {
  constructor() {
    this.types = Object.freeze({
      CONFIRM_1: 'confirm_1',
      ERROR_1: 'error_1',
      CONFIRM_2: 'confirm_2',
      ERROR_2: 'error_2',
      CONFIRM_3: 'confirm_3',
      ERROR_3: 'error_3',
    });
  }

  static MergeOptions(props, modalOptions, defaultType) {
    const componentPropsData = Object.assign(
      {
        type: defaultType,
      },
      props
    );

    return Object.assign(
      {
        componentPropsData,
      },
      modalOptions
    );
  }

  confirm(props, modalOptions) {
    return this.show(
      this.constructor.MergeOptions(props, modalOptions, this.types.CONFIRM_1)
    );
  }

  error(props, modalOptions) {
    return this.show(
      this.constructor.MergeOptions(props, modalOptions, this.types.ERROR_1)
    );
  }

  /**
   * @param error {Object|String}
   * @returns {Promise}
   */
  serverError(error) {
    return new Promise((resolve) => {
      try {
        // make error human readable
        if (_.isEmpty(error)) {
          error = null;
        } else if (typeof error === 'object') {
          error = JSON.stringify(error, null, '  ');
        } else if (typeof error !== 'string') {
          error = null;
        }
      } catch (xcp) {
        error = null;
      }

      app.delayedSpinner.hide();
      this.error(
        {
          type: this.types.ERROR_3,
          title: 'Sorry!',
          description: 'Looks like there may have been a server error.',
          buttonNoText: 'Close',
          buttonYesText: 'Reload',
          showContactCsm: true,
          csmSentenceText: 'Please contact',
          csmLinkText: 'support',
          csmSentenceTextEnd: 'so our team can begin an investigation.',
          csmChatMessage:
            'Hi, \n' +
            'Something went wrong, can you please check?\n' +
            'Thanks\n' +
            (error ? `Details: ${error}\n` : ''),
        },
        {}
      ).then((res) => {
        if (res.action) {
          app.stop();
          window.location.reload();
        } else {
          resolve(error);
        }
      });
    });
  }

  show(options) {
    const promise = new _.ColdPromise();

    // wt-base-modal options
    // dialog options will be in componentPropsData
    options = Object.assign(
      {
        component: 'wt-base-dialog',
        type: 'small',
        closeOnClickOut: false,
      },
      options || {}
    );

    const dialog = app.showModal(options);

    dialog.$on('close', (data) => {
      // if not action, set action null
      if (!data.action && !data.e) {
        data = {
          action: null,
          e: data,
        };
      }

      promise.resolve(data);
    });

    return promise;
  }
};

export default app.namespace.Controller.Dialog;
